import TrixEditor from './TrixEditor'

export default TrixEditor
